export default __webpack_public_path__ + "static/media/dishwasher.c10f9b8e.svg";